
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12.9","height":"12.857"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".55","fill":"#424242"}},[_c('path',{attrs:{"data-name":"Path 3145","d":"M12.578 8.447a.314.314 0 01-.322-.3A7.717 7.717 0 004.385.613a.304.304 0 110-.609 8.81 8.81 0 013.318.64 8.511 8.511 0 012.707 1.745 8.08 8.08 0 011.824 2.588 7.8 7.8 0 01.668 3.17.314.314 0 01-.324.3z"}}),_c('path',{attrs:{"data-name":"Path 3146","d":"M10.526 7.56a.314.314 0 01-.323-.3 4.8 4.8 0 00-4.9-4.692.304.304 0 110-.609 5.737 5.737 0 012.161.417 5.538 5.538 0 011.762 1.136 5.265 5.265 0 011.187 1.684 5.073 5.073 0 01.435 2.063.313.313 0 01-.322.301z"}}),_c('path',{attrs:{"data-name":"Path 3147","d":"M8.571 7.099a.314.314 0 01-.323-.3 2.423 2.423 0 00-2.471-2.367.304.304 0 110-.609 3.168 3.168 0 012.2.873 2.89 2.89 0 01.911 2.1.313.313 0 01-.317.303z"}}),_c('path',{attrs:{"data-name":"Path 3148","d":"M0 3.767A3.1 3.1 0 011.75.999a.677.677 0 01.082-.028.943.943 0 01.313-.032 3.272 3.272 0 01.649.089l.052.017c.08.026.332.142.484.62l.731 2.1s.215.569-.152.874a.446.446 0 00-.034.03l-.684.684a.626.626 0 00-.168.3.374.374 0 00.034.29.708.708 0 01.047.087 8.474 8.474 0 003.777 3.759.522.522 0 00.614-.13l.534-.522a.623.623 0 00.063-.072.806.806 0 01.97-.269l2.219.757.051.017a.78.78 0 01.531.626l.016.106a1.976 1.976 0 01-.01.792 2.914 2.914 0 01-2.886 1.763A6.091 6.091 0 015.8 11.742q-.067-.046-.136-.088A13.907 13.907 0 01.77 6.471 6.558 6.558 0 010 3.767z"}})])])
          )
        }
      }
    